import { render } from "./AccountLock.vue?vue&type=template&id=b4a962c6&scoped=true"
import script from "./AccountLock.vue?vue&type=script&lang=js"
export * from "./AccountLock.vue?vue&type=script&lang=js"

import "./AccountLock.vue?vue&type=style&index=0&id=b4a962c6&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a962c6"]])

export default __exports__